import React from "react";
import { Instagram, Mail, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#030303] border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-24 md:pt-32 pb-10">
        {/* Massive typographic logo */}
        <div className="overflow-hidden mb-16">
          <h2 className="font-display font-extralight text-[16vw] leading-[0.85] tracking-tighter text-white">
            Paradise<span className="italic font-light text-[#E2B464]">.</span>
          </h2>
          <p className="font-display font-extrabold text-[16vw] leading-[0.85] tracking-tighter text-zinc-800">
            Studios.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pt-10 border-t border-white/10">
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E2B464] mb-3">
              Visit
            </p>
            <p className="text-zinc-300 leading-relaxed">
              2587–2615 Gibbston Valley Highway
              <br />
              Gibbston, Central Otago
              <br />
              New Zealand 9371
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E2B464] mb-3">
              Contact
            </p>
            <a
              href="mailto:bookings@paradisestudiosnz.com"
              className="block text-zinc-300 hover:text-white transition-colors"
            >
              bookings@paradisestudiosnz.com
            </a>
            <p className="text-zinc-300 mt-1">+64 21 133 0045</p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E2B464] mb-3">
              Follow
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/paradisestudiosqueenstown"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 inline-flex items-center justify-center border border-white/10 hover:border-[#E2B464] hover:text-[#E2B464] transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="mailto:bookings@paradisestudiosnz.com"
                aria-label="Email"
                className="w-10 h-10 inline-flex items-center justify-center border border-white/10 hover:border-[#E2B464] hover:text-[#E2B464] transition-colors"
              >
                <Mail className="w-4 h-4" />
              </a>
              <a
                href="https://www.google.com/maps/place/Victoria+Flats,+Otago,+New+Zealand"
                target="_blank"
                rel="noreferrer"
                aria-label="Map"
                className="w-10 h-10 inline-flex items-center justify-center border border-white/10 hover:border-[#E2B464] hover:text-[#E2B464] transition-colors"
              >
                <MapPin className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div className="md:col-span-2 md:text-right">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#E2B464] mb-3">
              Action
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 text-white hover:text-[#E2B464] transition-colors"
            >
              Brief us <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
          <p>© {new Date().getFullYear()} Paradise Studios · All rights reserved</p>
          <p>45° 02' S · 168° 49' E</p>
        </div>
      </div>
    </footer>
  );
}
